export const reassignAndTerminateReassignTask_actionType = {
    REASSIGN_AND_TERMINATE_REASSIGN_TASK: "REASSIGN_AND_TERMINATE_REASSIGN_TASK",
    REASSIGN_AND_TERMINATE_REASSIGN_TASK_SUCCESS: "REASSIGN_AND_TERMINATE_REASSIGN_TASK_SUCCESS",
    REASSIGN_AND_TERMINATE_REASSIGN_TASK_ERROR: "REASSIGN_AND_TERMINATE_REASSIGN_TASK_ERROR",
    REASSIGN_AND_TERMINATE_REASSIGN_TASK_RESET: "REASSIGN_AND_TERMINATE_REASSIGN_TASK_RESET"
};